import { RELATED_SERVICE_ITEM_IN_VIEWPORT } from 'features/related-services';
import { getRelatedServices } from 'features/related-services/ducks/selectors';
import { put, select, takeEvery } from 'redux-saga/effects';
import { EffectR } from 'types/utils';
import { createAction } from 'typesafe-actions';

export type RelatedServiceGaPayload = {
  productName: string;
  productId: string;
  productPrice: string;
  productPosition: string;
  serviceKey: string;
};

/**
 * Cобытие должно срабатывать при попадании услуги во viewport.
 *
 * @see https://docs.google.com/document/d/1rdaDo_lgIIxoOgSocvCEtCk-kazxZirnyQzQ7uuhfog/edit
 */
export const gaViewService = createAction('GA:impressions')<{
  elementType: 'service';
  elementBlock: 'productDetail / services'; // блок, в котором расположен элемент

  productName: string; // название услуги
  productId: string; // id услуги
  productPrice: string; // цена услуги
  productPosition: string; // позиция слева-направо и сверху-вниз от 1
  productBelong: 'LeroyMerlinServices'; // константа, всегда 'LeroyMerlinServices'
}>();

export function* putGaViewService(title: string, serviceId: string, price: string, position: string) {
  yield put(
    gaViewService({
      elementType: 'service',
      elementBlock: 'productDetail / services',
      productName: title,
      productId: serviceId,
      productPrice: price,
      productPosition: position,
      productBelong: 'LeroyMerlinServices',
    }),
  );
}

export function* runGaViewServiceDetector() {
  yield takeEvery(RELATED_SERVICE_ITEM_IN_VIEWPORT, function* handle() {
    const servicesArr = (yield select(getRelatedServices)) as EffectR.Select<typeof getRelatedServices>;

    for (const [position, service] of servicesArr.entries()) {
      yield putGaViewService(
        `${service.title}`,
        `${service.serviceId}`,
        `${service.price.value}`,
        `${position + 1}`,
      );
    }
  });
}
